<template>
  <span>
    <template v-if="persons < 4">
      <img
        v-for="i in persons"
        :key="i"
        src="../../assets/icons/person.svg"
        class="mr-1"
        alt="person"
      />
    </template>
    <template v-else>
      <img src="../../assets/icons/person.svg" class="mr-1" alt="person" />
      x {{ persons }}
    </template>
  </span>
</template>

<script>
export default {
  name: "GuestIcons",
  props: {
    persons: {
      type: Number,
      required: true,
    },
  },
};
</script>
